export default "__VITE_ASSET__67d360e0__"